namespace Matrix.Data {
    export interface DateForm {
        DateKey: Serenity.DateEditor;
        DateName: Serenity.StringEditor;
        DayOfWeek: Serenity.IntegerEditor;
        DayNameOfWeek: Serenity.StringEditor;
        DayOfMonth: Serenity.IntegerEditor;
        DayOfYear: Serenity.IntegerEditor;
        WeekdayWeekend: Serenity.StringEditor;
        WeekOfYear: Serenity.IntegerEditor;
        MonthName: Serenity.StringEditor;
        MonthOfYear: Serenity.IntegerEditor;
        IsLastDayOfMonth: Serenity.StringEditor;
        CalendarQuarter: Serenity.IntegerEditor;
        CalendarYear: Serenity.IntegerEditor;
        CalendarYearMonth: Serenity.StringEditor;
        CalendarYearQtr: Serenity.StringEditor;
        FiscalMonthOfYear: Serenity.IntegerEditor;
        FiscalQuarter: Serenity.IntegerEditor;
        FiscalYear: Serenity.IntegerEditor;
        FiscalYearMonth: Serenity.StringEditor;
        FiscalYearQtr: Serenity.StringEditor;
        IsBusinessDay: Serenity.StringEditor;
        IsLastBusinessDayOfMonth: Serenity.StringEditor;
        IsFirstBusinessDayOfMonth: Serenity.StringEditor;
    }

    export class DateForm extends Serenity.PrefixedContext {
        static formKey = 'Data.Date';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DateForm.init)  {
                DateForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;

                Q.initFormType(DateForm, [
                    'DateKey', w0,
                    'DateName', w1,
                    'DayOfWeek', w2,
                    'DayNameOfWeek', w1,
                    'DayOfMonth', w2,
                    'DayOfYear', w2,
                    'WeekdayWeekend', w1,
                    'WeekOfYear', w2,
                    'MonthName', w1,
                    'MonthOfYear', w2,
                    'IsLastDayOfMonth', w1,
                    'CalendarQuarter', w2,
                    'CalendarYear', w2,
                    'CalendarYearMonth', w1,
                    'CalendarYearQtr', w1,
                    'FiscalMonthOfYear', w2,
                    'FiscalQuarter', w2,
                    'FiscalYear', w2,
                    'FiscalYearMonth', w1,
                    'FiscalYearQtr', w1,
                    'IsBusinessDay', w1,
                    'IsLastBusinessDayOfMonth', w1,
                    'IsFirstBusinessDayOfMonth', w1
                ]);
            }
        }
    }
}
